import React, {Fragment, useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from 'react-router';
import Loader from "../../components/Loader/Loader";
import savingDefaultsLottie from '../../assets/images/saving_defaults_lottie.json';
import delpoyAlertsLottie from '../../assets/images/deploy_alerts_lottie.json';
import classnames from "classnames";
import {
  getNewRelicDefaultThreshold as onGetNewRelicDefaultThreshold,
  getNewRelicDynamicDefaultThreshold as onGetNewRelicDynamicDefaultThreshold,
  getNewRelicResources as onGetNewRelicResources,
  putNewRelicThreshold as onPutNewRelicThreshold,
  postNewRelicDisableThresholdAlerts as onPostNewRelicDisableThresholdAlerts,
  postNewRelicEnableThresholdAlerts as onPostNewRelicEnableThresholdAlerts
} from "../../store/actions";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {threshold_types as THRESHOLD_TYPE} from "constants/data_types";
import Switch from "react-switch";
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Col,
  Modal,
  ModalHeader,
  Row,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledAccordion, Tooltip
} from "reactstrap";

import {
  getNRDisplayName as getName,
  getStateSpecificNRLogo
} from "../../helpers/component_helpers";

const NewRelicThresholds = props => {
  const params = useParams()
  const dispatch = useDispatch();
  const [thresholdBreakdown, setthresholdBreakdown] = useState({});
  const [subscribemodal, setSubscribemodal] = useState(false);
  const [subscribemodalDynamicAlert, setSubscribemodalDynamicAlert] = useState(false);
  const [changedValues, setchangedValues] = useState({});
  const [changedValuesDynamicAlert, setchangedValuesDynamicAlert] = useState({});
  const [modalChangedValues, setModalChangedValues] = useState({});
  const [modalChangedValuesDynamicAlert, setModalChangedValuesDynamicAlert] = useState({});
  const [modalChangedKey, setModalChangedKey] = useState();
  const [modalChangedKeyDynamicAlert, setModalChangedKeyDynamicAlert] = useState();
  const [ttop, settop] = useState(false);
  const [dttop, setdtop] = useState(false);

  const [dynamicThresholdBreakdown, setdynamicThresholdBreakdown] = useState({});

  const changeHeaders = ['Key', 'Old Value', 'New Value']

  const {thresholds} = useSelector(state => ({
    thresholds: state.Dashboard.new_relic_default_threshold || []
  }));

  const {dynamic_thresholds} = useSelector(state => ({
    dynamic_thresholds: state.Dashboard.new_relic_dynamic_default_threshold || []
  }));

  // const [tooltipOpen, setTooltipOpen] = useState(false);
  // const [currentIndex, setCurrentIndex] = useState(null);
  //
  // const toggle = (index) => {
  //   setTooltipOpen(!tooltipOpen);
  //   setCurrentIndex(index);
  // };
  // const newCurrentIndex = useRef(null);
  // const handleMouseOver = (index) => {
  //   setCurrentIndex(index);
  //   newCurrentIndex.current = index;
  //   setTooltipOpen(true);
  // };
  //
  // const handleMouseOut = () => {
  //   setTooltipOpen(false);
  //   newCurrentIndex.current = null;
  //   setCurrentIndex(null);
  // };

  useEffect(() => {
    dispatch(onGetNewRelicDefaultThreshold(THRESHOLD_TYPE.STATIC));
  }, [onGetNewRelicDefaultThreshold]);

  useEffect(() => {
    dispatch(onGetNewRelicDynamicDefaultThreshold(THRESHOLD_TYPE.DYNAMIC));
  }, [onGetNewRelicDynamicDefaultThreshold]);

  const {new_relic_resources} = useSelector(state => ({
    new_relic_resources: state.Dashboard.new_relic_resources,
  }));
  useEffect(() => {
    dispatch(onGetNewRelicResources());
  }, [onGetNewRelicResources]);

  useEffect(() => {
    var dynamic_threshold_breakdown = {};
    var resource_names = [];
    if (new_relic_resources.length > 0 && dynamic_thresholds.length > 0) {
      new_relic_resources.map((resource, index) => {
        resource_names.push(resource.resource_name)
      })
      dynamic_thresholds.map((threshold, index) => {
        if (resource_names.includes(threshold.metric.master_resource_name)) {
          if (dynamic_threshold_breakdown[threshold.metric.master_resource_name] === undefined) {
            dynamic_threshold_breakdown[threshold.metric.master_resource_name] = []
          }
          dynamic_threshold_breakdown[threshold.metric.master_resource_name].push(threshold)
        }
      })
      setdynamicThresholdBreakdown(dynamic_threshold_breakdown)
    }
  }, [dynamic_thresholds, new_relic_resources]);


  useEffect(() => {
    var threshold_breakdown = {};
    var resource_names = [];
    if (new_relic_resources.length > 0 && thresholds.length > 0) {
      new_relic_resources.map((resource, index) => {
        resource_names.push(resource.resource_name)
      })
      thresholds.map((threshold, index) => {
        if (resource_names.includes(threshold.metric.master_resource_name)) {
          if (threshold_breakdown[threshold.metric.master_resource_name] === undefined) {
            threshold_breakdown[threshold.metric.master_resource_name] = []
          }
          threshold_breakdown[threshold.metric.master_resource_name].push(threshold)
        }
      })
      setthresholdBreakdown(threshold_breakdown)
    }
  }, [thresholds, new_relic_resources]);

  const handleFormChange = (index, event, threshold_title, threshold_type) => {

    if (threshold_type === THRESHOLD_TYPE.STATIC) {
      var values = [...thresholdBreakdown[threshold_title]];
      var changed_values = {...changedValues};
    } else if (threshold_type === THRESHOLD_TYPE.DYNAMIC) {
      var values = [...dynamicThresholdBreakdown[threshold_title]];
      var changed_values = {...changedValuesDynamicAlert};
    }

    var title = values[index]['metric']['name']
    if (changed_values[threshold_title] === undefined) {
      changed_values[threshold_title] = {}
    }
    if (changed_values[threshold_title][title] === undefined) {
      changed_values[threshold_title][title] = {}
    }
    if (changed_values[threshold_title][title][event.target.name] === undefined) {
      changed_values[threshold_title][title][event.target.name] = {}
      changed_values[threshold_title][title][event.target.name] = {
        'id': values[index]['id'],
        'title': values[index]['metric']['name'],
        'name': event.target.name,
        'threshold_type': threshold_type,
        'old': values[index][event.target.name],
        'new': event.target.value
      }
    } else {
      if (changed_values[threshold_title][title][event.target.name]['old'] === event.target.value) {
        delete changed_values[threshold_title][title][event.target.name]
      } else {
        changed_values[threshold_title][title][event.target.name]['new'] = event.target.value
      }
    }
    changed_values[threshold_title][title][event.target.name].threshold_type = threshold_type

    if (Object.keys(changed_values[threshold_title][title]).length !== 0) {
      changed_values[threshold_title][title].threshold_type = threshold_type
      changed_values[threshold_title][title].threshold_id = values[index]['id']
    }

    if (threshold_type === THRESHOLD_TYPE.STATIC) {
      setchangedValues(changed_values);
    } else if (threshold_type === THRESHOLD_TYPE.DYNAMIC) {
      setchangedValuesDynamicAlert(changed_values);
    }

    values[index][event.target.name] = event.target.value;
  };

  const handleSubmit = (key) => {
    var alerts_update = []
    Object.entries(changedValues[key]).map(([parent_key, changedValue], index) => {
      var payload = {}
      payload = {
        'threshold_id': changedValue.threshold_id,
        'threshold_type': changedValue.threshold_type
      }
      Object.entries(changedValue).map(([key, value], index2) => {
        payload[value.name] = value.new
      })
      alerts_update.push(payload)
    })
    alerts_update.map((alert, index) => {
      dispatch(onPutNewRelicThreshold(alert));
    })
    setSubscribemodal(false);
    var changed_values = {...changedValues};
    delete changed_values[key];
    setchangedValues(changed_values);
  };

  const handleSubmitDynamicAlerts = (key) => {
    var alerts_update = []
    Object.entries(changedValuesDynamicAlert[key]).map(([parent_key, changedValue], index) => {
      var payload = {}
      payload = {
        'threshold_id': changedValue.threshold_id,
        'threshold_type': changedValue.threshold_type
      }
      Object.entries(changedValue).map(([key, value], index2) => {
        payload[value.name] = value.new
      })
      alerts_update.push(payload)
    })

    alerts_update.map((alert, index) => {
      dispatch(onPutNewRelicThreshold(alert));
    })

    setSubscribemodalDynamicAlert(false);
    var changed_values = {...changedValuesDynamicAlert};
    delete changed_values[key];
    setchangedValuesDynamicAlert(changed_values);
  };


  const handleSave = (threshold_title) => {
    setModalChangedValues(changedValues[threshold_title])
    setModalChangedKey(threshold_title)
    setSubscribemodal(true);
  };

  const handleSaveDynamicAlert = (threshold_title) => {
    setModalChangedValuesDynamicAlert(changedValuesDynamicAlert[threshold_title])
    setModalChangedKeyDynamicAlert(threshold_title)
    setSubscribemodalDynamicAlert(true);
  }

  const headers = ['Metric Name', 'Operator', 'Value', 'Duration', 'Action'];
  const dynamicHeaders = ['Metric Name', 'Baseline Direction', 'Deviation Count', 'Duration', 'Action'];

  const ThresholdOperator = ['ABOVE', 'BELOW', 'EQUAL'];
  const ThresholdOperatorDisplay = {
    'ABOVE': '>',
    'BELOW': '<',
    'EQUAL': '='
  };
  const DynamicThresholdOperator = ['LOWER_ONLY', 'UPPER_AND_LOWER', 'UPPER_ONLY'];

  const [isLoading, setIsLoading] = useState(false);

  const startLoading = () => {
    setIsLoading(true);

    // Simulate loading process
    setTimeout(() => {
      setIsLoading(false);
    }, 4000);
  };

  const [activeTab, setactiveTab] = useState("1");

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };

  const OffSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 1
        }}
      >
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 1
        }}
      >
      </div>
    );
  };

  const [isLoading_DisableAlert, setisLoading_DisableAlert] = useState(false);
  const [isLoading_EnableAlert, setisLoading_EnableAlert] = useState(false);

  const [tanomaly, settanomaly] = useState(false);

  const handleDisable = (alert_id) => {
    const payload = {
      'threshold_id': alert_id,
      'enable': false,
    }
    dispatch(onPostNewRelicDisableThresholdAlerts(payload));
  };

  const handleEnable = (alert_id) => {
    const payload = {
      'threshold_id': alert_id,
      'enable': true,
    }
    dispatch(onPostNewRelicEnableThresholdAlerts(payload));
  };

  const [toggles, setToggles] = useState({});
  const [dynamicToggles, setDynamicToggles] = useState({});

  useEffect(() => {
    if (thresholdBreakdown) {
      const initialToggles = {};
      Object.keys(thresholdBreakdown).forEach(key => {
        const alertsArray = thresholdBreakdown[key];
        alertsArray.forEach(alert => {
          initialToggles[alert.id] = alert.enabled === null ? true : alert.enabled;
        });
      });
      setToggles(initialToggles);
    }
  }, [thresholdBreakdown]);

  useEffect(() => {
    if (dynamicThresholdBreakdown) {
      const initialToggles = {};
      Object.keys(dynamicThresholdBreakdown).forEach(key => {
        const alertsArray = dynamicThresholdBreakdown[key];
        alertsArray.forEach(alert => {
          initialToggles[alert.id] = alert.enabled === null ? true : alert.enabled;
        });
      });
      setDynamicToggles(initialToggles);
    }
  }, [dynamicThresholdBreakdown]);


  const toggleAlert = (index3, alertId, thresholdType) => {
    let updatedToggles = {};

    if (thresholdType === THRESHOLD_TYPE.STATIC) {
      updatedToggles = {...toggles};
      updatedToggles[alertId] = !updatedToggles[alertId];
      setToggles(updatedToggles);
    } else if (thresholdType === THRESHOLD_TYPE.DYNAMIC) {
      updatedToggles = {...dynamicToggles};
      updatedToggles[alertId] = !updatedToggles[alertId];
      setDynamicToggles(updatedToggles);
    }
    if (!updatedToggles[alertId]) {
      handleDisable(alertId);
    } else {
      handleEnable(alertId);
    }
  };

  return (
    <React.Fragment>
      <Row>
        <Col lg="8">
          <Breadcrumbs
            title={"All Thresholds"}
            breadcrumbItem={"All Thresholds"}
          />
        </Col>
      </Row>

      <div>
        <Nav pills className="nav-custom">
          <NavItem className="nav-item-custom">
            <NavLink
              className={classnames({
                active: activeTab === "1",
              })}
              onClick={() => {
                toggleTab("1");
              }}
            >
              <span className="d-sm-block">Static Alert Thresholds</span>
            </NavLink>
          </NavItem>
          <NavItem className="nav-item-custom">
            <NavLink
              className={classnames({
                active: activeTab === "2",
              })}
              onClick={() => {
                toggleTab("2");
              }}
            >
              <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <span className="d-sm-block" style={{marginRight: '10px'}}>Anomaly Detection Alert Thresholds</span>
                <span
                  id="TooltipAnomaly"
                  onMouseOver={() => settanomaly(true)}
                  onMouseLeave={() => settanomaly(false)}
                  className="alert-icon"
                  style={{marginRight: '10px'}}
                >
                  <i className="mdi mdi-information-outline text-warning fix-flicker"/>
                </span>
                <Tooltip
                  placement="right"
                  isOpen={tanomaly}
                  target="TooltipAnomaly"
                  toggle={() => {
                    settanomaly(!tanomaly);
                  }}
                  style={{
                    border: "2px solid #f1b44c",
                    borderRadius: "10px",
                    backgroundColor: "#2a3042",
                    zIndex: 1
                  }}
                  className="fix-flicker"
                >
                  Anomaly Alerts are based on standard deviation of metric
                </Tooltip>
              </div>
            </NavLink>
          </NavItem>
        </Nav>
        <hr style={{border: "1px solid #556ee6", backgroundColor: "#556ee6", width: "100%", marginTop: "-1px",}}/>

        <TabContent activeTab={activeTab} className="py-4">
          <TabPane tabId="1">
            <div>
              <Row>
                <Col lg={12}>
                  <UncontrolledAccordion defaultOpen={"1"}>
                    {
                      Object.entries(thresholdBreakdown).map(([key, value], index) => {
                        return (
                          <Fragment key={index}>
                            <AccordionItem>
                              <AccordionHeader targetId={(index + 1).toString()}>
                                <Row className="full-width">
                                  <Col lg="6">
                                    <h5 className="change-table-text">
                                      <img src={getStateSpecificNRLogo(key)} className="resource-logo"></img>
                                      <span className="text-primary">{getName(key)}</span>
                                    </h5>
                                  </Col>
                                  <Col lg="6">
                                    {
                                      (changedValues[key] !== undefined && Object.entries(changedValues).length > 0) ?
                                        <button
                                          type="button"
                                          className="btn btn-primary bx-pull-right w-md"
                                          onClick={() => handleSave(key)}
                                        >
                                          Save Default Threshold
                                        </button> : null
                                    }
                                  </Col>
                                </Row>
                              </AccordionHeader>
                              <AccordionBody accordionId={(index + 1).toString()}>
                                <div className="table-responsive react-table">
                                  <Table bordered hover className="table-purple">
                                    <thead className="table-light table-nowrap" style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                    <tr>
                                      {headers.map((header, index2) => (
                                        <th key={index2}>
                                          <div className="mb-2 text-white">
                                            {header}
                                          </div>
                                        </th>
                                      ))}
                                    </tr>
                                    </thead>
                                    <tbody style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                    {
                                      value.map((alert, index3) => {
                                        return (
                                          <Fragment key={index3}>
                                            <tr>
                                              <td className="text-white">
                                                {/*<div className="d-inline-flex align-items-center">*/}
                                                {alert.metric.name}
                                                {/*  <div className="d-inline-flex px-3"*/}
                                                {/*       style={{paddingTop: "18px"}}*/}
                                                {/*  >*/}
                                                {/*    <p id={`TooltipExample_${index}_${index3}`}*/}
                                                {/*       onMouseOver={() => handleMouseOver(`${index}_${index3}`)}*/}
                                                {/*       onMouseLeave={() => handleMouseOut()}>*/}
                                                {/*      <i className="bx bx-info-circle font-size-18"*/}
                                                {/*      ></i>*/}
                                                {/*    </p>*/}
                                                {/*    <Tooltip*/}
                                                {/*        placement="top"*/}
                                                {/*        isOpen={tooltipOpen && newCurrentIndex.current === `${index}_${index3}`}*/}
                                                {/*        target={`TooltipExample_${index}_${index3}`}*/}
                                                {/*        toggle={() => toggle(`${index}_${index3}`)}*/}
                                                {/*        style={{*/}
                                                {/*          border: "2px solid #f1b44c",*/}
                                                {/*          borderRadius: "10px",*/}
                                                {/*          backgroundColor: "#2a3042",*/}
                                                {/*          zIndex: 1*/}
                                                {/*        }}*/}
                                                {/*    >*/}
                                                {/*      {alert.metric.description}*/}
                                                {/*    </Tooltip>*/}
                                                {/*  </div>*/}
                                                {/*</div>*/}
                                              </td>
                                              <td>
                                                <div className="input">
                                                  <select
                                                    id="formrow-InputState"
                                                    name="threshold_operator"
                                                    className="custom_select text-center"
                                                    value={alert.threshold_operator}
                                                    onChange={event => handleFormChange(index3, event, key, THRESHOLD_TYPE.STATIC)}
                                                  >
                                                    {ThresholdOperator.map((item, key) => (
                                                      <option key={key} value={item}>
                                                        {ThresholdOperatorDisplay[item] || item}
                                                      </option>))}
                                                  </select>
                                                </div>
                                              </td>
                                              <td>
                                                <input
                                                  type="number"
                                                  value={alert.threshold_value}
                                                  name="threshold_value"
                                                  className="input text-center"
                                                  id="autoSizingInputGroup"
                                                  placeholder="Threshold Value"
                                                  style={{width: '100px'}}
                                                  onChange={event => handleFormChange(index3, event, key, THRESHOLD_TYPE.STATIC)}
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="number"
                                                  value={alert.threshold_duration}
                                                  name="threshold_duration"
                                                  className="input text-center"
                                                  id="autoSizingInputGroup"
                                                  style={{width: '100px'}}
                                                  placeholder="Threshold Duration"
                                                  onChange={event => handleFormChange(index3, event, key, THRESHOLD_TYPE.STATIC)}
                                                />
                                              </td>
                                              <td>
                                                {
                                                  alert?.enabled === true || alert?.enabled === null ?
                                                    (
                                                      <>
                                                        <div
                                                          id="TooltipTop"
                                                          onMouseOver={() => settop(true)}
                                                          onMouseLeave={() => settop(false)}
                                                          className="alert-icon"
                                                        >
                                                          <Switch
                                                            key={toggles[alert.id]}
                                                            uncheckedIcon={<OffSymbol/>}
                                                            checkedIcon={<OnSymbol/>}
                                                            className="me-1 mb-sm-8 mb-2"
                                                            onColor="#34c38f"
                                                            offColor="#f46a6a"
                                                            height={20}
                                                            width={44}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 5px"
                                                            onChange={() => toggleAlert(index3, alert.id, THRESHOLD_TYPE.STATIC)}
                                                            checked={toggles[alert.id] || false}
                                                          /></div>
                                                        <Tooltip
                                                          placement="top"
                                                          isOpen={ttop}
                                                          target="TooltipTop"
                                                          toggle={() => {
                                                            settop(!ttop);
                                                          }}
                                                          style={{
                                                            border: "2px solid #f1b44c",
                                                            borderRadius: "10px",
                                                            backgroundColor: "#2a3042",
                                                            zIndex: 1
                                                          }}
                                                          className="fix-flicker"
                                                        >
                                                          Enable/Disable metric
                                                        </Tooltip>
                                                      </>
                                                    ) :
                                                    (
                                                      <>
                                                        <div
                                                          id="DisabledTooltipTop"
                                                          onMouseOver={() => setdtop(true)}
                                                          onMouseLeave={() => setdtop(false)}
                                                          className="alert-icon"
                                                        ><Switch
                                                          key={toggles[alert.id]}
                                                          uncheckedIcon={<OffSymbol/>}
                                                          checkedIcon={<OnSymbol/>}
                                                          className="me-1 mb-sm-8 mb-2"
                                                          offColor="#f46a6a"
                                                          onColor="#34c38f"
                                                          height={20}
                                                          width={44}
                                                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                          activeBoxShadow="0px 0px 1px 5px"
                                                          onChange={() => toggleAlert(index3, alert.id, THRESHOLD_TYPE.STATIC)}
                                                          checked={toggles[alert.id] || false}
                                                        /></div>
                                                        <Tooltip
                                                          placement="top"
                                                          isOpen={dttop}
                                                          target="DisabledTooltipTop"
                                                          toggle={() => {
                                                            setdtop(!dttop);
                                                          }}
                                                          style={{
                                                            border: "2px solid #f1b44c",
                                                            borderRadius: "10px",
                                                            backgroundColor: "#2a3042",
                                                            zIndex: 1
                                                          }}
                                                          className="fix-flicker"
                                                        >
                                                          Enable/Disable metric
                                                        </Tooltip>
                                                      </>
                                                    )
                                                }
                                              </td>
                                            </tr>
                                          </Fragment>
                                        )
                                      })
                                    }
                                    </tbody>
                                  </Table>
                                </div>

                              </AccordionBody>
                            </AccordionItem>
                          </Fragment>
                        )
                      })
                    }
                  </UncontrolledAccordion>
                </Col>
              </Row>
            </div>
          </TabPane>

          <TabPane tabId="2">
            <div>
              <Row>
                <Col lg={12}>
                  <UncontrolledAccordion defaultOpen={"1"}>
                    {
                      Object.entries(dynamicThresholdBreakdown).map(([key, value], index) => {
                        if (value.length > 0) {
                          return (
                            <Fragment key={index}>
                              <AccordionItem>
                                <AccordionHeader targetId={(index + 1).toString()}>
                                  <Row className="full-width">
                                    <Col lg="6">
                                      <h5 className="change-table-text">
                                        <img src={getStateSpecificNRLogo(key)} className="resource-logo"></img>
                                        <span className="text-primary">{getName(key)}</span>
                                      </h5>
                                    </Col>
                                    <Col lg="6">
                                      {
                                        (changedValuesDynamicAlert[key] !== undefined && Object.entries(changedValuesDynamicAlert).length > 0) ?
                                          <button
                                            type="button"
                                            className="btn btn-primary bx-pull-right w-md"
                                            onClick={() => handleSaveDynamicAlert(key)}
                                          >
                                            Save Default Threshold
                                          </button> : null
                                      }
                                    </Col>
                                  </Row>
                                </AccordionHeader>
                                <AccordionBody accordionId={(index + 1).toString()}>
                                  <div className="table-responsive react-table">
                                    <Table bordered hover className="table-purple">
                                      <thead className="table-light table-nowrap">
                                      <tr>
                                        {dynamicHeaders.map((header, index2) => (
                                          <th key={index2}>
                                            <div className="mb-2 text-white">
                                              {header}
                                            </div>
                                          </th>
                                        ))}
                                      </tr>
                                      </thead>
                                      <tbody>
                                      {
                                        value.map((alert, index3) => {
                                          return (
                                            <Fragment key={index3}>
                                              <tr>
                                                <td className={'text-white'}>
                                                  {/*<div className="d-inline-flex align-items-center">*/}
                                                  {alert.metric.name}
                                                  {/*  <div className="d-inline-flex px-3"*/}
                                                  {/*       style={{paddingTop: "18px"}}*/}
                                                  {/*  >*/}
                                                  {/*    <p id={`TooltipExample_${index}_${index3}`}*/}
                                                  {/*       onMouseOver={() => handleMouseOver(`${index}_${index3}`)}*/}
                                                  {/*       onMouseLeave={() => handleMouseOut()}>*/}
                                                  {/*      <i className="bx bx-info-circle font-size-18"*/}
                                                  {/*      ></i>*/}
                                                  {/*    </p>*/}
                                                  {/*    <Tooltip*/}
                                                  {/*        placement="top"*/}
                                                  {/*        isOpen={tooltipOpen && newCurrentIndex.current === `${index}_${index3}`}*/}
                                                  {/*        target={`TooltipExample_${index}_${index3}`}*/}
                                                  {/*        toggle={() => toggle(`${index}_${index3}`)}*/}
                                                  {/*        style={{*/}
                                                  {/*          border: "2px solid #f1b44c",*/}
                                                  {/*          borderRadius: "10px",*/}
                                                  {/*          backgroundColor: "#2a3042",*/}
                                                  {/*          zIndex: 1*/}
                                                  {/*        }}*/}
                                                  {/*    >*/}
                                                  {/*      {alert.metric.description}*/}
                                                  {/*    </Tooltip>*/}
                                                  {/*  </div>*/}
                                                  {/*</div>*/}
                                                </td>
                                                <td>
                                                  <div className="input">
                                                    <select
                                                      id="formrow-InputState"
                                                      name="threshold_operator"
                                                      className="custom_select"
                                                      value={alert.threshold_operator}
                                                      onChange={event => handleFormChange(index3, event, key, THRESHOLD_TYPE.DYNAMIC)}
                                                    >
                                                      {DynamicThresholdOperator.map((item, key1) => (
                                                        <option key={key1}
                                                                value={item}>{item}</option>))}
                                                    </select>
                                                  </div>
                                                </td>
                                                <td>
                                                  <input
                                                    type="number"
                                                    value={alert.deviation_count}
                                                    name="deviation_count"
                                                    className="input"
                                                    id="autoSizingInputGroup"
                                                    placeholder="Deviation Count"
                                                    onChange={event => handleFormChange(index3, event, key, THRESHOLD_TYPE.DYNAMIC)}
                                                  />
                                                </td>
                                                <td>
                                                  <input
                                                    type="number"
                                                    value={alert.threshold_duration}
                                                    name="threshold_duration"
                                                    className="input"
                                                    id="autoSizingInputGroup"
                                                    placeholder="Threshold Duration"
                                                    onChange={event => handleFormChange(index3, event, key, THRESHOLD_TYPE.DYNAMIC)}
                                                  />
                                                </td>
                                                <td>
                                                  {
                                                    alert?.enabled === true || alert?.enabled === null ?
                                                      (
                                                        <>
                                                          <div
                                                            id="TooltipTop"
                                                            onMouseOver={() => settop(true)}
                                                            onMouseLeave={() => settop(false)}
                                                            className="alert-icon"
                                                          >
                                                            <Switch
                                                              key={dynamicToggles[alert.id]}
                                                              uncheckedIcon={<OffSymbol/>}
                                                              checkedIcon={<OnSymbol/>}
                                                              className="me-1 mb-sm-8 mb-2"
                                                              onColor="#34c38f"
                                                              offColor="#f46a6a"
                                                              height={20}
                                                              width={44}
                                                              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                              activeBoxShadow="0px 0px 1px 5px"
                                                              onChange={() => toggleAlert(index3, alert.id, THRESHOLD_TYPE.DYNAMIC)}
                                                              checked={dynamicToggles[alert.id] || false}
                                                            /></div>
                                                          <Tooltip
                                                            placement="top"
                                                            isOpen={ttop}
                                                            target="TooltipTop"
                                                            toggle={() => {
                                                              settop(!ttop);
                                                            }}
                                                            style={{
                                                              border: "2px solid #f1b44c",
                                                              borderRadius: "10px",
                                                              backgroundColor: "#2a3042",
                                                              zIndex: 1
                                                            }}
                                                          >
                                                            Enable/Disable metric
                                                          </Tooltip>
                                                        </>
                                                      ) :
                                                      (
                                                        <>
                                                          <div
                                                            id="DisabledTooltipTop"
                                                            onMouseOver={() => setdtop(true)}
                                                            onMouseLeave={() => setdtop(false)}
                                                            className="alert-icon"
                                                          ><Switch
                                                            key={dynamicToggles[alert.id]}
                                                            uncheckedIcon={<OffSymbol/>}
                                                            checkedIcon={<OnSymbol/>}
                                                            className="me-1 mb-sm-8 mb-2"
                                                            offColor="#f46a6a"
                                                            onColor="#34c38f"
                                                            height={20}
                                                            width={44}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 5px"
                                                            onChange={() => toggleAlert(index3, alert.id, THRESHOLD_TYPE.DYNAMIC)}
                                                            checked={dynamicToggles[alert.id] || false}
                                                          /></div>
                                                          <Tooltip
                                                            placement="top"
                                                            isOpen={dttop}
                                                            target="DisabledTooltipTop"
                                                            toggle={() => {
                                                              setdtop(!dttop);
                                                            }}
                                                            style={{
                                                              border: "2px solid #f1b44c",
                                                              borderRadius: "10px",
                                                              backgroundColor: "#2a3042",
                                                              zIndex: 1
                                                            }}
                                                          >
                                                            Enable/Disable metric
                                                          </Tooltip>
                                                        </>
                                                      )
                                                  }
                                                </td>
                                              </tr>
                                            </Fragment>
                                          )
                                        })
                                      }
                                      </tbody>
                                    </Table>
                                  </div>

                                </AccordionBody>
                              </AccordionItem>
                            </Fragment>
                          )
                        }
                      })
                    }
                  </UncontrolledAccordion>
                </Col>
              </Row>
            </div>
          </TabPane>
        </TabContent>
      </div>

      <Loader
        isOpen={isLoading}
        lottieJson={savingDefaultsLottie}
        messageHeader="Saving Thresholds"
        message="Please wait while your default thresholds are being updated."
      />
      <Loader
        isOpen={isLoading_DisableAlert}
        lottieJson={delpoyAlertsLottie}
        messageHeader="Disabling Alert"
        message="The alert is not deleted. You can enable it any time again."
      />
      <Loader
        isOpen={isLoading_EnableAlert}
        lottieJson={delpoyAlertsLottie}
        messageHeader="Enabling Alert"
        message="That was easy! Hang tight while we enable your alert again."
      />
      <Modal
        isOpen={subscribemodal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        size="xl"
        tabIndex="-1"
      >
        <div className="modal-header border-bottom-1 text-center">
          <h4 className="text-primary ">Your are about to change the defaults for {getName(modalChangedKey)}!</h4>
          <button type="button" className="btn-close"
                  onClick={() => {
                    setSubscribemodal(!subscribemodal);
                  }} aria-label="Close">
          </button>
        </div>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <p className="text-muted font-size-14 mb-4">This change will affect all the new alerts that will be set up for {getName(modalChangedKey)}.</p>
                <Table bordered hover className="table-purple">
                  <thead className="table-light table-nowrap">
                  <tr>
                    <th>Alert Name</th>
                    {changeHeaders.map((header, index) => (
                      <th key={index}>{header}</th>
                    ))}
                  </tr>
                  </thead>
                  {
                    Object.entries(modalChangedValues).map(([parent_key, changedValue], index) => {
                      return (
                        <Fragment key={index}>
                          <tbody>
                          {
                            Object.entries(changedValue).map(([key, value], index2) => {
                              if (key !== 'threshold_id' && key !== 'threshold_type') {
                                return (
                                  <Fragment key={index2}>
                                    <tr>
                                      <td>
                                        {parent_key}
                                      </td>
                                      <td>
                                        {value.name}
                                      </td>
                                      <td>
                                        {value.old}
                                      </td>
                                      <td>
                                        <b>{value.new}</b>
                                      </td>
                                    </tr>
                                  </Fragment>
                                )
                              }
                            })
                          }
                          </tbody>

                        </Fragment>
                      )
                    })
                  }
                </Table>
                <Button
                  color="primary"
                  type="button"
                  id="button-addon2"
                  onClick={() => {
                    startLoading();
                    handleSubmit(modalChangedKey);
                  }}>
                  Save Alerts
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={subscribemodalDynamicAlert}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        size="xl"
        tabIndex="-1"
      >
        <div className="modal-header border-bottom-1 text-center">
          <h4 className="text-primary ">Your are about to change the defaults for {getName(modalChangedKeyDynamicAlert)} Anomaly Detection Alerts!</h4>
          <button type="button" className="btn-close"
                  onClick={() => {
                    setSubscribemodalDynamicAlert(!subscribemodalDynamicAlert);
                  }} aria-label="Close">
          </button>
        </div>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <p className="text-muted font-size-14 mb-4">This change will affect all the new alerts that will be set up
                  for {getName(modalChangedKeyDynamicAlert)}.</p>
                <Table bordered hover className="table-purple">
                  <thead className="table-light table-nowrap">
                  <tr>
                    <th>Alert Name</th>
                    {changeHeaders.map((header, index) => (
                      <th key={index}>{header}</th>
                    ))}
                  </tr>
                  </thead>
                  {
                    Object.entries(modalChangedValuesDynamicAlert).map(([parent_key, changedValue], index) => {
                      return (
                        <Fragment key={index}>
                          <tbody>
                          {
                            Object.entries(changedValue).map(([key, value], index2) => {
                              if (key !== 'threshold_id' && key !== 'threshold_type') {
                                return (
                                  <Fragment key={index2}>
                                    <tr>
                                      <td>
                                        {parent_key}
                                      </td>
                                      <td>
                                        {value.name}
                                      </td>
                                      <td>
                                        {value.old}
                                      </td>
                                      <td>
                                        <b>{value.new}</b>
                                      </td>
                                    </tr>
                                  </Fragment>
                                )
                              }
                            })
                          }
                          </tbody>

                        </Fragment>
                      )
                    })
                  }
                </Table>
                <Button
                  color="primary"
                  type="button"
                  id="button-addon2"
                  onClick={() => {
                    startLoading();
                    handleSubmitDynamicAlerts(modalChangedKeyDynamicAlert);
                  }}>
                  Save Alerts
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

NewRelicThresholds.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
  onGetServices: PropTypes.func,
};

export default withRouter(NewRelicThresholds);
